import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core'
import { provideRouter } from '@angular/router'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { providePrimeNG } from 'primeng/config'
import Delvag from '@delvag/primeng-theme'
import { AbstractSecurityStorage, DefaultLocalStorageService, LogLevel, provideAuth, withAppInitializerAuthCheck } from 'angular-auth-oidc-client'
import { routes } from './app.routes'
import { FeatureFlagService } from '@services/feature-flag.service'
import { DEBOUNCE_CONFIG } from '@app/config/DebounceConfig'
import { authInterceptor } from '@app/core/auth/interceptors/auth.interceptor'
import { environment } from '@environments/environment'

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: DEBOUNCE_CONFIG,
      useValue: 500
    },
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    providePrimeNG({
      theme: {
        preset: Delvag,
        options: {
          darkModeSelector: '.dark',
          prefix: 'p-delvag'
        }
      },
      ripple: true
    }),
    provideAppInitializer(() => {
      const featureFlagService = inject(FeatureFlagService)
      return featureFlagService.init()
    }),
    provideAuth({
      config: {
        authority: environment.oidcProviderUrl,
        clientId: environment.oidcClientId,
        historyCleanupOff: false,
        redirectUrl: `${globalThis.location.origin}/auth/callback`,
        postLogoutRedirectUri: globalThis.location.origin,
        scope: environment.oidcScopes,
        responseType: 'code',
        triggerAuthorizationResultEvent: true,
        silentRenew: true,
        useRefreshToken: true,
        ignoreNonceAfterRefresh: true,
        triggerRefreshWhenIdTokenExpired: true,
        renewTimeBeforeTokenExpiresInSeconds: 30,
        logLevel: LogLevel.Debug,
        autoUserInfo: true,
        startCheckSession: true,
      },
    }, withAppInitializerAuthCheck()),
    { provide: AbstractSecurityStorage, useClass: DefaultLocalStorageService },
  ]
}
